// client/src/components/ForgotPasswordPage.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Container, TextField, Button, Typography, Alert, Box } from '@mui/material';
import AppBarHeader from './AppBarHeader';
import axiosInstance from '../axiosInstance';

function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await axiosInstance.post('/auth/forgot-password', { email });
      setSubmitted(true);
    } catch (err) {
      setError(err.response?.data?.message || 'Something went wrong. Please try again.');
    }
  };

  return (
    <div>
      <AppBarHeader />
      <Container maxWidth="sm" sx={{ mt: 8 }}>
        <Typography variant="h5" gutterBottom>Forgot Password</Typography>
        {submitted ? (
          <Alert severity="success">
            If that address is registered, a reset link has been sent. Check your inbox — if you don't see it, take a look in your spam or junk folder too.
          </Alert>
        ) : (
          <Box component="form" onSubmit={handleSubmit}>
            <Typography variant="body2" sx={{ mb: 2 }}>
              Enter your account email address and we will send you a password reset link.
            </Typography>
            {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
            <TextField
              fullWidth label="Email Address" type="email"
              value={email} onChange={(e) => setEmail(e.target.value)}
              required sx={{ mb: 2 }}
            />
            <Button type="submit" variant="contained" fullWidth>Send Reset Link</Button>
          </Box>
        )}
        <Box sx={{ mt: 2, textAlign: 'center' }}>
          <Button component={Link} to="/login" variant="text">Back to Login</Button>
        </Box>
      </Container>
    </div>
  );
}

export default ForgotPasswordPage;
